import React from 'react';
import {reset} from 'redux-form';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import { stopSubmit, formValueSelector } from 'redux-form'
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentRemove from 'material-ui/svg-icons/content/remove';
import DateRangeIcon from 'material-ui/svg-icons/action/date-range';
import ListIcon from 'material-ui/svg-icons/action/list';
import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';
import * as colors from 'material-ui/styles/colors';


import PageBase from '../../../components/PageBase';
import DataTables from '../../../components/DataTables/DataTables'

import listHeader from './listHeader'
import gStyles from '../../../styles'

import UserMasterForm from './UserMasterForm'

import * as actions from '../../../actions'


import ReactTooltip from 'react-tooltip'
import * as commons from "../../../commons";

const _ = require('lodash');
const moment = require('moment');
const MASTER_TYPE = "user"

const validate = values => {
  const errors = {}
  const requiredFields = [
    "branchOfficeId",
    "departmentId",
    "name",
    "email",
    "password",
    "permission",
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })


  if (values.password && !/^(?=.*\d)(?=.*[a-z])\w{8,24}$/.test(values.password)) {
    errors.password = '英数混在8〜24文字にして下さい。'
  }

  if (values.xronosUserId && !commons.validateNumber(values.xronosUserId)) {
    errors.xronosUserId = '数値入力を入力して下さい。'
  }

  const paidHolidayErrors = validatePaidHolidayList(values.paidHolidayList)
  if (paidHolidayErrors && paidHolidayErrors.length != 0) {
    errors.paidHolidayList = paidHolidayErrors
  }

  const userPriceErrors = validateUserPriceList(values.userPriceList)
  if (userPriceErrors && userPriceErrors.length != 0) {
    errors.userPriceList = userPriceErrors
  }

  return errors
}

const validatePaidHolidayList = paidHolidayList => {

  const errors = []
  if (!paidHolidayList || paidHolidayList.length == 0) {
      return
  }

  paidHolidayList.forEach((paidHoliday, index) => {
    const error = {}
    if (paidHoliday.count && !commons.validateNumber(paidHoliday.count)) {
      error.count = '数値入力を入力して下さい。'
    }

    if (paidHoliday.date || paidHoliday.count) {
      if (!paidHoliday.date) {
        error.date = '必須入力'
      }
      if (!paidHoliday.count) {
        error.count = '必須入力'
      }
    }

    if (Object.keys(error).length != 0) {
      errors[index] = error
    }

  })

  return errors

}

const validateUserPriceList = userPriceList => {

  if (!userPriceList || userPriceList.length == 0) {
    return
  }

  const errors = []
  userPriceList.forEach((userPrice, index) => {
    const error = {}

    if (!userPrice.startDate) {
      error.startDate = '必須入力'
    }
    if (!userPrice.priceId) {
      error.priceId = '必須入力'
    }

    if (Object.keys(error).length != 0) {
      errors[index] = error
    }

  })

  return errors

}


const validateSearch = values => {
  const errors = {}
  if (values.paidHoliday && !/^([1-9]\d*|0)(\.\d+)?$/.test(values.paidHoliday)) {
    errors.paidHoliday = '数値を入力して下さい'
  }
  return errors
}

class UserMasterPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      open: false,
    }
  }

  componentDidMount() {

    const {
      form,
      page
    } = this.props

    this.props.handleInit(form, page)

  }

  handlePreviousPageClick(form, page, editIndex) {

    if (editIndex) {
      alert('編集モード中はページ移動はできません。')
      return
    }

    const prevPage = page - 1
    this.props.handlePageClick(prevPage, form)
  }

  handleNextPageClick(form, page, editIndex) {
    if (editIndex) {
      alert('編集モード中はページ移動はできません。')
      return
    }

    const nextPage = page + 1
    this.props.handlePageClick(nextPage, form)
  }

  handleConfirmOpen(id, item) {
    this.setState(Object.assign({}, this.state, {
      id: id,
      item: item,
      open: true
    }))
  }

  handleConfirmClose() {
    this.setState(Object.assign({}, this.state, {
      open: false
    }))
  }

  handlePageReset(form) {
    this.setState(Object.assign({}, this.state, {
      page: 1,
    }))
  }

  render() {

    const {
      selectData,
      selectedBranchOfficeId,
      handleFormSearchClick,
      handleFormRegistClick,
      handleFormEditClick,
      handleFormDeleteClick,
      handleFormResetClick,
      handleLocalStorageSave,
      tmpForm,
      history
    } = this.props

    const page = this.props.page
    const count = this.props.count
    const form = this.props.form || {}
    const list = this.props.list || []

    let editIndex;
    const dataList = list.map((x, index) => {

      const linkStyle = form.id ? {pointerEvents: 'none'} : {}

      const actions = (
        <div style={{display: "flex", justifyContent: 'flex-end'}}>
          <div style={{ margin: '10px 10px' }}>
            <span data-tip="タイムカード出力">
              <Link className="button" to={`/timecard/${x.id}/${x.name}`} style={linkStyle}>
                <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} disabled={form.id ? true : false}>
                  <ArrowDwonloadIcon />
                </FloatingActionButton>
              </Link>
            </span>
          </div>
          <div style={{ margin: '10px 10px' }}>
            <span data-tip="代休操作">
              <Link className="button" to={`/subHoliday/${x.id}/${x.name}`} style={linkStyle}>
                <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} disabled={form.id ? true : false}>
                  <ListIcon />
                </FloatingActionButton>
              </Link>
            </span>
          </div>
          <div style={{ margin: '10px 10px' }}> 
            <span data-tip="労務操作">
              <Link className="button" to={`/roumu/${x.id}`} style={linkStyle}>
                <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} disabled={form.id ? true : false}>
                  <DateRangeIcon />
                </FloatingActionButton>
              </Link>
            </span>
          </div>
          <div style={{ margin: '10px 10px' }}> 
            <span data-tip="編集">
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} onTouchTap={!form.id && handleFormEditClick(x.id)} disabled={form.id ? true : false}>
              <ContentCreate /> 
            </FloatingActionButton>
            </span>
          </div>
          <div style={{ margin: '10px 10px' }}> 
            <span data-tip="削除">
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.red300}
              onTouchTap={!form.id && this.handleConfirmOpen.bind(this,x.id, x.name)} disabled={form.id ? true : false}
              > 
              <ContentRemove /> 
            </FloatingActionButton>
            </span>
          </div>
        </div>
      )

      if (form.id == x.id) {
        editIndex = index
      }

      return {
        branchOfficeName: x.branchOfficeName,
        departmentName: x.departmentName,
        name: x.name,
        email: x.email,
        paidHoliday: x.paidHoliday,
        priceName: x.priceName,
        permissionName: x.permissionName,
        actions: actions,
      }

    })

    const dialogActions = [
      <FlatButton
        label="キャンセル"
        primary={true}
        onTouchTap={this.handleConfirmClose.bind(this)}
      />,
      <FlatButton
        label="削除"
        primary={true}
        keyboardFocused={true}
        onTouchTap={handleFormDeleteClick(this.state.id, page, this.handleConfirmClose.bind(this), form)}
      />,
    ];

    const editColor = form.id && {backgroundColor: colors.lightGreen50}

    if (_.isEmpty(form.paidHolidayList)) {
      form.paidHolidayList = [{date: null, count: null}]
    }
    if (_.isEmpty(form.userPriceList)) {
      form.userPriceList = [{startDate: null, priceId: null}]
    }

    return (

      <PageBase title="社員マスタ" >

        <div>

          <div style={gStyles.searchBoxContainer}>

            <Paper style={{...gStyles.contentsPaper, ...editColor}}>
              <UserMasterForm 
                selectedBranchOfficeId={selectedBranchOfficeId}
                branchOfficeData={selectData.branchOffice}
                departmentData={selectData.department}
                priceData={selectData.price}
                onFormRegistClick={handleFormRegistClick(form.id, page, tmpForm)}
                onFormResetClick={handleFormResetClick}
                onFormSearchClick={handleFormSearchClick(this.handlePageReset.bind(this))}
                initialValues={form}
                onLocalStorageSave={handleLocalStorageSave}
              />
            </Paper>

          </div>

          <Paper style={{...gStyles.contentsPaper}}>
            <DataTables
              editIndex={editIndex}
              tableStyle={{overflow: 'hidden', tableLayout: ''}}
              tableBodyStyle={{overflowX: 'auto'}}
              height={'auto'}
              showRowHover={true}
              columns={listHeader}
              data={dataList}
              page={page}
              showRowSizeControls={false}
              onNextPageClick={this.handleNextPageClick.bind(this, form, page, editIndex)}
              onPreviousPageClick={this.handlePreviousPageClick.bind(this, form, page, editIndex)}
              count={count}
            />
            <ReactTooltip />

          </Paper>

        </div>

         <Dialog
          title="マスター削除"
          actions={dialogActions}
          modal={true}
          open={this.state.open}
          onRequestClose={this.handleConfirmClose.bind(this)}
        >
          {this.state.item} を削除します。よろしいですか？
        </Dialog> 

      </PageBase>

    )
  }

}

const selector = formValueSelector(`${MASTER_TYPE}MasterForm`)
const mapStateToProps = (state) => ({
  list: state.master.list[MASTER_TYPE] ,
  count: state.master.count[MASTER_TYPE],
  form: state.master.form[MASTER_TYPE],
  page: state.master.page[MASTER_TYPE],
  tmpForm: state.master.tmpForm[MASTER_TYPE],
  selectData: state.master.selectData,
  selectedBranchOfficeId: selector(state, 'branchOfficeId'),
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : (form, page) => {
    dispatch(actions.systemMasterInit(MASTER_TYPE, form, page))
  },
  handleFormEditClick : (id) => () => {
    dispatch(reset(`${MASTER_TYPE}MasterForm`));
    dispatch(actions.userMasterFormEdit(MASTER_TYPE, id))
  },
  handleFormDeleteClick : (id, page, close, tmpForm) => () => {
    close()
    dispatch(actions.userMasterFormDelete(MASTER_TYPE, id, page, tmpForm))
  },
  handleFormResetClick : () => {
    dispatch(actions.reducerMasterFormReset(MASTER_TYPE))
  },

  handleFormRegistClick : (id, page, tmpForm) => (values) => {
    const errors = validate(values)
    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`${MASTER_TYPE}MasterForm`, errors))
      return
    }


    let newValues = {}
    if (values.paidHolidayList) {

      const newPaidHolidayList = values.paidHolidayList.map(x => {
        let date
        if (x.date) {
          date = moment(x.date, 'YYYY/MM/DD').format('YYYY/MM/DD')
        }
        return {
          date: date,
          count: x.count
        }
      })

      newValues = Object.assign(values, {paidHolidayList: newPaidHolidayList})
    } else {
      newValues = values
    }

    if (values.userPriceList) {

      const newUserPriceList = values.userPriceList.map(x => {
        let date
        if (x.startDate) {
          date = moment(x.startDate, 'YYYY/MM/DD').format('YYYY/MM/DD')
        }

        return {
          startDate: date,
          priceId: x.priceId
        }
      })

      newValues = Object.assign(newValues, {userPriceList: newUserPriceList})
    }

    dispatch(actions.userMasterFormRegist(MASTER_TYPE, id, newValues, page, tmpForm))
  },
  handleFormSearchClick : (pageReset) => (values) => {
    const errors = validateSearch(values)
    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`${MASTER_TYPE}MasterForm`, errors))
      return
    }
    pageReset()

    let newValues = {}
    if (values.paidHolidayList) {

      const newPaidHolidayList = values.paidHolidayList.map(x => {
        let date
        if (x.date) {
          date = moment(x.date, 'YYYY/MM/DD').format('YYYY/MM/DD')
        }

        return {
          date: date,
          count: x.count
        }
      })

      newValues = Object.assign(values, {paidHolidayList: newPaidHolidayList})
    } else {
      newValues = values
    }

    if (values.userPriceList) {

      const newUserPriceList = values.userPriceList.map(x => {
        let date
        if (x.startDate) {
          date = moment(x.startDate, 'YYYY/MM/DD').format('YYYY/MM/DD')
        }

        return {
          startDate: date,
          priceId: x.priceId
        }
      })

      newValues = Object.assign(newValues, {userPriceList: newUserPriceList})
    }

    dispatch(actions.userMasterSearch(MASTER_TYPE, 1, newValues))
  },
  handlePageClick : (page, tmpForm) => {
    dispatch(actions.userMasterSearch(MASTER_TYPE, page, tmpForm))
  },
  handleLocalStorageSave : (values) => {
    if (!window.localStorage) {
      window.alert('お使いのブラウザでは固定できません。他のブラウザを使用して下さい。')
      return
    }
    window.localStorage.setItem(MASTER_TYPE, JSON.stringify(values))
    dispatch(actions.reducerSnackBar(true, '入力値を固定しました。', colors.green400))
  },
})

UserMasterPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(UserMasterPage)

export default UserMasterPage;



// WEBPACK FOOTER //
// ./src/containers/master/user/UserMasterPage.js